import Header from "../Common/Header";
import Footer from "../Common/Footer";
import { Link } from "react-router-dom";
import React, { useState } from "react";
import Carousel from 'react-bootstrap/Carousel';



function Home() {

  //https://crm.smartuworld.com/mobile/WebContact?name=anuj&email=anuj04@gmail.com&mobile=8445989182&subjecttext=testafaffa&messagetext=theradrt&optdndtag=opttagyes&customerpartner=testpartner&acceptprivacytag=accepttag
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    subjecttext: "",
    customerpartner: "", // Default selection for visit type
    messagetext: "",
    Product: "",
    optdndtag: true,
    acceptprivacytag: true,
  });

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(""); // State to store the selected value

  const handleProductChange = (event) => {
    alert(event.target.value);
    setSelectedProduct(event.target.value); // Update state when an option is selected
  };

  const UpdateProductChange = (Product) => {
    //alert(Product);
    setSelectedProduct(Product);
    setFormData({
      ...formData,
      [Product]: Product,
    });
  };
  // Handle input changes
  const handleChange = (e) => {
    debugger;
    const { name, value, type, checked } = e.target;

    if (name === "Product") {
      setSelectedProduct(value);
      setFormData({
        ...formData,
        [name]: value,
      });
      return;
    }
    if (name === "optdndtag") {
      setFormData({
        ...formData,
        [name]: "opttagyes",
      });
      return;
    }
    if (name === "acceptprivacytag") {
      setFormData({
        ...formData,
        [name]: "accepttag",
      });
      return;
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    debugger;
    e.preventDefault();

    fetch("https://crm.smartuworld.com/mobile/WebContact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data?.status) {
          alert(data?.message);
          setFormData({
            name: "",
            email: "",
            mobile: "",
            subjecttext: "",
            customerpartner: "",
            messagetext: "",
            optdndtag: true,
            Product: "",
            acceptprivacytag: true,
          });
        }
      })
      .catch((error) => {
        alert("Try after some time");
        console.error("Error:", error);
      });
  };

  // useEffect(() => {
  
  //     setOpen(true);
   
  // }, []);


  return (
    <>
      <Header />

      {/* Start Banner Area */}
      <div className="banner-area">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-6">


              <Carousel autoplay>

                <Carousel.Item>

                  <div className="single-banner-image">
                    <div className="banner-image3s">
                      <div className="banner-main-img">
                        <img src="assets/images/banner/hp-banner-img.svg" alt="banner-1" />
                      </div>

                      <div className="banner-shape-1">
                        <img
                          src="assets/images/banner/banner-shape-2.webp"
                          alt="banner-shape"
                        />
                      </div>
                    </div>

                  </div>
                  <div className="single-banner-content">
                    <h2>Looking for loan?
                    </h2>
                    <div class="banner-btn d-flex align-items-center pt-30">
                      <a href="#" class="default-btn">Request for free demo</a>
                    </div>


                  </div>

                </Carousel.Item>
                <Carousel.Item>


                  <div className="single-banner-image">
                    <div className="banner-image3s">
                      <div className="banner-main-img">
                        <img src="assets/images/banner/search-banner.png" alt="banner-1" />
                      </div>

                      <div className="banner-shape-1">
                        <img
                          src="assets/images/banner/banner-shape-2.webp"
                          alt="banner-shape"
                        />
                      </div>
                    </div>

                  </div>
                  <div className="single-banner-content">
                    <h2>Looking for best Credit Card?
                    </h2>
                    <div class="banner-btn d-flex align-items-center pt-30">
                      <a href="#" class="default-btn">Request for free demo</a>
                    </div>


                  </div>
                </Carousel.Item>
                <Carousel.Item>

                  <div className="single-banner-image">
                    <div className="banner-image3s">
                      <div className="banner-main-img">
                        <img src="assets/images/banner/hp-banner-img.svg" alt="banner-1" />
                      </div>

                      <div className="banner-shape-1">
                        <img
                          src="assets/images/banner/banner-shape-2.webp"
                          alt="banner-shape"
                        />
                      </div>
                    </div>

                  </div>
                  <div className="single-banner-content">
                    <h2>Looking for best Insurance Services?
                    </h2>
                    <div class="banner-btn d-flex align-items-center pt-30">
                      <a href="#" class="default-btn">Request for free demo</a>
                    </div>


                  </div>

                </Carousel.Item>

              </Carousel>



            </div>

            <div className="col-lg-6">
              <div className="contact-form">
                <h5 style={{ marginBottom: 15 }}>Connect with us </h5>
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          id="name"
                          className="form-control"
                          placeholder="Name"
                          required=""
                          data-error="Please enter your name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                        />
                        <div className="help-block with-errors" />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          className="form-control"
                          placeholder="Your Email"
                          required=""
                          data-error="Please enter your email"
                        />
                        <div className="help-block with-errors" />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          id="phone_number"
                          name="mobile"
                          value={formData.mobile}
                          onChange={handleChange}
                          placeholder="Phone"
                          required=""
                          data-error="Please enter your number"
                          className="form-control"
                        />
                        <div className="help-block with-errors" />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <select name="Product" className="form-control" value={selectedProduct}
                          onChange={handleChange} >
                          <option value="">Select Product</option>
                          <option value="Credit Cards">Credit Cards</option>
                          <option value="Bank Accounts">Bank Accounts</option>
                          <option value="Personal Loan">Personal Loan</option>
                          <option value="Housing Loan">Housing Loan</option>
                          <option value="Business Loan">Business Loan</option>
                          <option value="Professional Loan">Professional Loan</option>
                          <option value="Gold Loan">Gold Loan</option>
                          <option value="Vehicle Loan">Vehicle Loan</option>
                          <option value="Micro Loan">Micro Loan</option>
                          <option value="Motor Insurance">Motor Insurance</option>
                          <option value="Life Insurance">Life Insurance</option>
                          <option value="Health Insurance">Health Insurance</option>
                          <option value="Group Insurance">Group Insurance</option>
                          <option value="Aeps">Aeps</option>
                          <option value="Bbps">Bbps</option>
                          <option value="Recharges">Recharges</option>
                          <option value="Dmt">DMT</option>
                          <option value="Passport">Passport</option>
                          <option value="Marriage Certificate">Marriage Certificate</option>
                          <option value="Driving License">Driving License</option>
                          <option value="Caste Certificate">Caste Certificate</option>
                          <option value="Income Certificate">Income Certificate</option>
                          <option value="Domicile Certificate">Domicile Certificate</option>
                          <option value="Birth Certificate">Birth Certificate</option>
                        </select>



                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          id="Subject"
                          name="subjecttext"
                          value={formData.subjecttext}
                          onChange={handleChange}
                          placeholder="Subject"
                          required=""
                          data-error="Please enter your subject"
                          className="form-control"
                        />
                        <div className="help-block with-errors" />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">

                        <div style={{ marginTop: 10 }}>
                          <input
                            type="radio"
                            id="partner"
                            name="customerpartner"
                            value="Partner"
                            checked={formData.customerpartner === "Partner"}
                            onChange={handleChange}
                          />
                          <label for="partner">As a Partner</label>
                          <input
                            type="radio"
                            id="customer"
                            name="customerpartner"
                            value="Customer"
                            checked={formData.customerpartner === "Customer"}
                            onChange={handleChange}
                            style={{ marginLeft: 20 }}
                          />
                          <label for="customer">As a Customer</label>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-group">
                        <textarea
                          name="messagetext"
                          value={formData.messagetext}
                          onChange={handleChange}
                          type="text"
                          className="form-control"
                          id="message"
                          cols={30}
                          rows={2}
                          placeholder="Message"
                          required=""
                          data-error="Write your message"
                          defaultValue={""}
                        />
                        <div className="help-block with-errors" />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-group">
                        <div className="form-check">
                          <input
                            name="optdndtag"
                            checked={formData.optdndtag}
                            onChange={handleChange}
                            defaultValue=" I authorize SmartuWorld and its representative to contact me with updates and notifications via Email, SMS, Whatsapp and call, This will override the registry on DND/NDNC."
                            className="form-check-input"
                            type="checkbox"
                            id="authorize"
                            required="required"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="authorize"
                          >
                            I authorize SmartuWorld and its representative to
                            contact me with updates and notifications via Email,
                            SMS, Whatsapp, Call and RCS, This will override the
                            registry on DND/NDNC.
                          </label>
                          <div className="help-block with-errors gridCheck-error" />
                        </div>
                      </div>
                      <div className="form-group">
                        <div className="form-check">
                          <input
                            name="acceptprivacytag"
                            defaultValue="I agree to the terms and privacy policy."
                            className="form-check-input"
                            type="checkbox"
                            id="gridCheck"
                            required="required"
                            checked={formData.acceptprivacytag}
                            onChange={handleChange}
                          />
                       <label
                            className="form-check-label"
                            htmlFor="gridCheck"
                          >
                            Accept{" "}
                            <Link to="/terms">
                              Terms Of Services
                            </Link>{" "}
                            and <Link to="/privacy">privacy policy</Link>
                          </label>
                          <div className="help-block with-errors gridCheck-error" />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-12">
                      <button type="submit" className="default-btn">
                        Submit Now
                      </button>
                      <div id="msgSubmit" className="h3 text-center hidden" />
                      <div className="clearfix" />
                    </div>
                  </div>
                </form>
              </div>
            </div>

          </div>
        </div>
        <div className="banner-shape-3">
          <img src="assets/images/banner/banner-shape-3.webp" alt="banner" />
        </div>
        <div className="banner-shape-4">
          <img src="assets/images/banner/banner-shape-4.webp" alt="banner" />
        </div>
        <div className="banner-shape-5">
          <img src="assets/images/banner/banner-shape-5.webp" alt="banner" />
        </div>
        <div className="banner-shape-7">
          <img src="assets/images/banner/banner-shape-7.webp" alt="banner" />
        </div>
      </div>
      {/* End Banner Area */}
      {/* Start Our Features area */}
      <div className="features-area pt-100 pb-70">
        <div className="container">
          <div className="section-title">

            <h2>Our Services</h2>
          </div>
          <div className="row">
            <div className="col-lg-12 col-sm-12 col-md-12">
              <div class="section-title leftalign">

                <span className="">Banking</span>
              </div>
            </div>

          </div>
          <div className="row parent">
            <div className="col-lg-3 col-sm-6 col-md-6">

              <div class="services-three-card ">
                <div className="child">
                  <div class="services-card d-flex align-items-center">
                    <div class="services-icon bg-icon-color">
                      <img src="assets/images/proicon/credit-card.svg" />
                    </div>
                    <h3>Credit Cards</h3>
                  </div>
                  <p>Apply for Credit Card Online & Get Instant Approval</p>
                  <a href="#" onClick={() => UpdateProductChange("Credit Cards")}
                    className="default-btn"                  >
                    Apply Now
                  </a>
                </div>

              </div>

            </div>
            <div className="col-lg-3 col-sm-6 col-md-6">
              <div class="services-three-card ">
                <div className="child">
                  <div class="services-card d-flex align-items-center">
                    <div class="services-icon bg-icon-color">
                      <img src="assets/images/proicon/bankaccount.svg" />
                    </div>
                    <h3>Bank Accounts</h3>
                  </div>
                  <p>Open Bank savings account from your home</p>
                  <a href="#" onClick={() => UpdateProductChange("Bank Accounts")} class="default-btn">Apply Now</a>
                </div>
              </div>


            </div>
            <div className="col-lg-3 col-sm-6 col-md-6">
              <div class="services-three-card">
                <div className="child">
                  <div class="services-card d-flex align-items-center">
                    <div class="services-icon bg-icon-color">
                      <img src="assets/images/proicon/personal-loan.svg" />
                    </div>
                    <h3>Personal Loan</h3>
                  </div>
                  <p>You can get a personal loan online instantly</p>
                  <a href="#" onClick={() => UpdateProductChange("Personal Loan")} class="default-btn">Apply Now</a>
                </div>
              </div>

            </div>
            <div className="col-lg-3 col-sm-6 col-md-6">

              <div class="services-three-card">
                <div className="child">
                  <div class="services-card d-flex align-items-center">
                    <div class="services-icon bg-icon-color">
                      <img src="assets/images/proicon/home-loan.svg" />
                    </div>
                    <h3>Housing Loan</h3>
                  </div>
                  <p>You can get a Housing loan online instantly

                  </p>
                  <a href="#" onClick={() => UpdateProductChange("Housing Loan")} class="default-btn">Apply Now</a>
                </div>
              </div>


            </div>

            <div className="col-lg-3 col-sm-6 col-md-6">

              <div class="services-three-card">
                <div className="child">
                  <div class="services-card d-flex align-items-center">
                    <div class="services-icon bg-icon-color">
                      <img src="assets/images/proicon/business-loan.svg" />
                    </div>
                    <h3>
                      Business Loan</h3>
                  </div>
                  <p>You can get a Business loan online instantly</p>
                  <a href="#" onClick={() => UpdateProductChange("Business Loan")} class="default-btn">Apply Now</a>
                </div>
              </div>



            </div>
            <div className="col-lg-3 col-sm-6 col-md-6">
              <div class="services-three-card">
                <div className="child">
                  <div class="services-card d-flex align-items-center">
                    <div class="services-icon bg-icon-color">
                      <img src="assets/images/proicon/professional-loan.svg" />
                    </div>
                    <h3>Professional Loan</h3>
                  </div>
                  <p>You can get a Professional loan online instantly</p>
                  <a href="#" onClick={() => UpdateProductChange("Professional Loan")} class="default-btn">Apply Now</a>
                </div>
              </div>

            </div>
            <div className="col-lg-3 col-sm-6 col-md-6">
              <div class="services-three-card">
                <div className="child">
                  <div class="services-card d-flex align-items-center">
                    <div class="services-icon bg-icon-color">
                      <img src="assets/images/proicon/gold-loan.svg" />
                    </div>
                    <h3>Gold Loan</h3>
                  </div>
                  <p>You can get a Gold loan online instantly</p>
                  <a href="#" onClick={() => UpdateProductChange("Gold Loan")} class="default-btn">Apply Now</a>
                </div>
              </div>

            </div>
            <div className="col-lg-3 col-sm-6 col-md-6">

              <div class="services-three-card">
                <div className="child">
                  <div class="services-card d-flex align-items-center">
                    <div class="services-icon bg-icon-color">
                      <img src="assets/images/proicon/car-loan.svg" />
                    </div>
                    <h3>Vehical Loan</h3>
                  </div>
                  <p>You can get a Vehical loan online instantly

                  </p>
                  <a href="#" onClick={() => UpdateProductChange("Vehicle Loan")} class="default-btn">Apply Now</a>
                </div>
              </div>


            </div>

            <div className="col-lg-3 col-sm-6 col-md-6">

              <div class="services-three-card">
                <div className="child">
                  <div class="services-card d-flex align-items-center">
                    <div class="services-icon bg-icon-color">
                      <img src="assets/images/proicon/micro-loan.svg" />
                    </div>
                    <h3>Micro Loans (Under ₹50K)</h3>
                  </div>
                  <p>Unlock Best Personal Loan Offers suitable for your needs from 30+ Lenders


                  </p>
                  <a href="#" onClick={() => UpdateProductChange("Micro Loan")} class="default-btn">Apply Now</a>
                </div>
              </div>

            </div>


          </div>


          <div className="row">
            <div className="col-lg-12 col-sm-12 col-md-12">
              <div class="section-title leftalign">

                <span className="">Insurance Services </span>
              </div>
            </div>
          </div>
          <div className="row parent">
            <div className="col-lg-3 col-sm-6 col-md-6">

              <div class="services-three-card">
                <div className="child">
                  <div class="services-card d-flex align-items-center">
                    <div class="services-icon bg-icon-color">
                      <img src="assets/images/proicon/moter-insurance.svg" />
                    </div>
                    <h3>Motor Insurance
                    </h3>
                  </div>
                  <p>Get Additional Protection On Your Car With Add Ons

                  </p>
                  <a href="#" onClick={() => UpdateProductChange("Motor Insurance")} class="default-btn">Apply Now</a>
                </div>
              </div>


            </div>
            <div className="col-lg-3 col-sm-6 col-md-6">
              <div class="services-three-card">
                <div className="child">
                  <div class="services-card d-flex align-items-center">
                    <div class="services-icon bg-icon-color">
                      <img src="assets/images/proicon/life-insurance-policy.svg" />
                    </div>
                    <h3>Life Insurance
                    </h3>
                  </div>
                  <p>1 Cr Life Cover @Rs 473/Month* Cheapest Prices,


                  </p>
                  <a href="#" onClick={() => UpdateProductChange("Life Insurance")} class="default-btn">Apply Now</a>
                </div>

              </div>
            </div>
            <div className="col-lg-3 col-sm-6 col-md-6">
              <div class="services-three-card">
                <div className="child">
                  <div class="services-card d-flex align-items-center">
                    <div class="services-icon bg-icon-color">
                      <img src="assets/images/proicon/health-insurance.svg" />
                    </div>
                    <h3>Health Insurance
                    </h3>
                  </div>
                  <p>Health insurance plans covers medical expenses

                  </p>
                  <a href="#" onClick={() => UpdateProductChange("Health Insurance")} class="default-btn">Apply Now</a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 col-md-6">

              <div class="services-three-card">
                <div className="child">
                  <div class="services-card d-flex align-items-center">
                    <div class="services-icon bg-icon-color">
                      <img src="assets/images/proicon/group-insurance.svg" />
                    </div>
                    <h3>Group Insurance
                    </h3>
                  </div>
                  <p>Group Insurance policy covers a professional



                  </p>
                  <a href="#" onClick={() => UpdateProductChange("Group Insurance")} class="default-btn">Apply Now</a>
                </div>

              </div>
            </div>



          </div>




          <div className="row">
            <div className="col-lg-12 col-sm-12 col-md-12">
              <div class="section-title leftalign">

                <span className="">Wallet Services
                </span>
              </div>
            </div>

          </div>
          <div className="row parent">
            <div className="col-lg-3 col-sm-6 col-md-6">

              <div class="services-three-card">
                <div className="child">
                  <div class="services-card d-flex align-items-center">
                    <div class="services-icon bg-icon-color">
                      <img src="assets/images/proicon/payment.svg" />
                    </div>
                    <h3>AePS
                    </h3>
                  </div>
                  <p>Aadhaar Enabled Payment System (AePS)     </p>
                  <a href="#" onClick={() => UpdateProductChange("Aeps")} class="default-btn">Apply Now</a>
                </div>
              </div>


            </div>
            <div className="col-lg-3 col-sm-6 col-md-6">
              <div class="services-three-card">
                <div className="child">
                  <div class="services-card d-flex align-items-center">
                    <div class="services-icon bg-icon-color">
                      <img src="assets/images/proicon/bharat-pay.svg" />
                    </div>
                    <h3>BBPS

                    </h3>
                  </div>
                  <p>Pay Bills On Bharat Bill Payment System


                  </p>
                  <a href="#" onClick={() => UpdateProductChange("Bbps")} class="default-btn">Apply Now</a>
                </div>

              </div>
            </div>
            <div className="col-lg-3 col-sm-6 col-md-6">
              <div class="services-three-card">
                <div className="child">
                  <div class="services-card d-flex align-items-center">
                    <div class="services-icon bg-icon-color">
                      <img src="assets/images/proicon/recharge.svg" />
                    </div>
                    <h3>Recharges
                    </h3>
                  </div>
                  <p>Fast & easy mobile recharge online

                  </p>
                  <a href="#" onClick={() => UpdateProductChange("Recharges")} class="default-btn">Apply Now</a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 col-md-6">

              <div class="services-three-card">
                <div className="child">
                  <div class="services-card d-flex align-items-center">
                    <div class="services-icon bg-icon-color">
                      <img src="assets/images/proicon/home-loan.svg" />
                    </div>
                    <h3>DMT
                    </h3>
                  </div>
                  <p>Send money to your loved ones instantly</p>
                  <a href="#" onClick={() => UpdateProductChange("Dmt")} class="default-btn">Apply Now</a>
                </div>

              </div>
            </div>



          </div>



          <div className="row">
            <div className="col-lg-12 col-sm-12 col-md-12">
              <div class="section-title leftalign">

                <span className="">G2C Services
                </span>
              </div>
            </div>
          </div>
          <div className="row parent">
            <div className="col-lg-3 col-sm-6 col-md-6">

              <div class="services-three-card">
                <div className="child">
                  <div class="services-card d-flex align-items-center">
                    <div class="services-icon bg-icon-color">
                      <img src="assets/images/proicon/passport.svg" />
                    </div>
                    <h3>Passport
                    </h3>
                  </div>
                  <p>An official document issued by a governmernt

                  </p>
                  <a href="#" onClick={() => UpdateProductChange("Passport")} class="default-btn">Apply Now</a>
                </div>
              </div>


            </div>
            <div className="col-lg-3 col-sm-6 col-md-6">
              <div class="services-three-card">
                <div className="child">
                  <div class="services-card d-flex align-items-center">
                    <div class="services-icon bg-icon-color">
                      <img src="assets/images/proicon/marriage-certificate.svg" />
                    </div>
                    <h3>Marriage Certificate


                    </h3>
                  </div>
                  <p>Get registered and apply for Marriage Certificate




                  </p>
                  <a href="#" onClick={() => UpdateProductChange("Marriage Certificate")} class="default-btn">Apply Now</a>
                </div>
              </div>

            </div>
            <div className="col-lg-3 col-sm-6 col-md-6">
              <div class="services-three-card">
                <div className="child">
                  <div class="services-card d-flex align-items-center">
                    <div class="services-icon bg-icon-color">
                      <img src="assets/images/proicon/driving-license.svg" />
                    </div>
                    <h3>Driving Licence

                    </h3>
                  </div>
                  <p>Now apply for Driving Licence through NDLS



                  </p>
                  <a href="#" onClick={() => UpdateProductChange("Driving License")} class="default-btn">Apply Now</a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 col-md-6">

              <div class="services-three-card">
                <div className="child">
                  <div class="services-card d-flex align-items-center">
                    <div class="services-icon bg-icon-color">
                      <img src="assets/images/proicon/cast-certificate.svg" />
                    </div>
                    <h3>Caste Certificate

                    </h3>
                  </div>
                  <p>Now apply for Caste Certificate online

                  </p>
                  <a href="#" onClick={() => UpdateProductChange("Caste Certificate")} class="default-btn">Apply Now</a>
                </div>
              </div>

            </div>

            <div className="col-lg-3 col-sm-6 col-md-6">

              <div class="services-three-card">
                <div className="child">
                  <div class="services-card d-flex align-items-center">
                    <div class="services-icon bg-icon-color">
                      <img src="assets/images/proicon/income-certification.svg" />
                    </div>
                    <h3>Income Certificate

                    </h3>
                  </div>
                  <p>This certificate establishes the annual income



                  </p>
                  <a href="#" onClick={() => UpdateProductChange("Income Certificate")} class="default-btn">Apply Now</a>
                </div>

              </div>

            </div>
            <div className="col-lg-3 col-sm-6 col-md-6">
              <div class="services-three-card">
                <div className="child">
                  <div class="services-card d-flex align-items-center">
                    <div class="services-icon bg-icon-color">
                      <img src="assets/images/proicon/domicile-certificate.svg" />
                    </div>
                    <h3>Domicile Certificate



                    </h3>
                  </div>
                  <p>Domicile certificate or residence certificate


                  </p>
                  <a href="#" onClick={() => UpdateProductChange("Domicile Certificate")} class="default-btn">Apply Now</a>
                </div>
              </div>

            </div>
            <div className="col-lg-3 col-sm-6 col-md-6">
              <div class="services-three-card">
                <div className="child">
                  <div class="services-card d-flex align-items-center">
                    <div class="services-icon bg-icon-color">
                      <img src="assets/images/proicon/birth-certificate.svg" />
                    </div>
                    <h3>Birth Certificate
                    </h3>
                  </div>
                  <p>Birth Certificate. Documents Required for Certificate

                  </p>
                  <a href="#" onClick={() => UpdateProductChange("Birth Certificate")} class="default-btn">Apply Now</a>
                </div>

              </div>
            </div>

          </div>


        </div>
      </div>
      {/* End Our Features area */}

      <>
        {/* Start Faq area */}
        <div className="faqs-area pt-100 pb-100">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="faqs-img">
                  <img src="assets/images/faq-img-1.webp" alt="faqs" />
                  <div className="faqs-img-2">
                    <img src="assets/images/faq-img-2.webp" alt="faqs" />
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="faqs-content">
                  <div className="section-title left-title">
                    <span className="top-title">Getting Started

                    </span>
                    <h2>Get Set Up And Start Spending With Your Card In Minutes.
                    </h2>
                  </div>
                  <div className="faqs-item">
                    <div className="accordion" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingOne">
                          <button
                            className="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >

                            1. Register In Minutes

                          </button>
                        </h2>
                        <div
                          id="collapseOne"
                          className="accordion-collapse collapse show"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <p>
                              Luptatem accusantium doloremque laudantium, totam rem
                              aper ab illo inventtatis quasit architecto beatae.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingTwo">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >

                            2. Tell Us About Your Business

                          </button>
                        </h2>
                        <div
                          id="collapseTwo"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingTwo"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <p>
                              Luptatem accusantium doloremque laudantium, totam rem
                              aper ab illo inventtatis quasit architecto beatae.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingThree">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseThree"
                            aria-expanded="false"
                            aria-controls="collapseThree"
                          >

                            3. Set Up A Transfer

                          </button>
                        </h2>
                        <div
                          id="collapseThree"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingThree"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <p>
                              Luptatem accusantium doloremque laudantium, totam rem
                              aper ab illo inventtatis quasit architecto beatae.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingFore">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFore"
                            aria-expanded="false"
                            aria-controls="collapseFore"
                          >

                            4. Pay For Your Transfer

                          </button>
                        </h2>
                        <div
                          id="collapseFore"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingFore"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <p>
                              Luptatem accusantium doloremque laudantium, totam rem
                              aper ab illo inventtatis quasit architecto beatae.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingFive">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFive"
                            aria-expanded="false"
                            aria-controls="collapseFive"
                          >

                            5. All Done

                          </button>
                        </h2>
                        <div
                          id="collapseFive"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingFive"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <p>
                              Luptatem accusantium doloremque laudantium, totam rem
                              aper ab illo inventtatis quasit architecto beatae.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End Faq area */}


        {/* start logo filter */}
        <section id="portfolio">
          <div className="container">

            <div>
              <button className="btn btn-default filter-button" data-filter="all">
                All
              </button>
              <button className="btn btn-default filter-button" data-filter="unsecuredloans">
                Unsecured Loans
              </button>
              <button className="btn btn-default filter-button" data-filter="creditcard">
                Credit Card
              </button>
              <button className="btn btn-default filter-button" data-filter="homeloan">
                Home Loan
              </button>
              {/* <button className="btn btn-default filter-button" data-filter="bureau">
                Credit Bureau
              </button> */}
              <button className="btn btn-default filter-button" data-filter="improvement">
                Credit Improvement
              </button>
            </div>
            <div className="row flx">
              <div className="gallery_product filter center homeloan">
                <img src="assets/images/logos/ABCapital.png" />
              </div>
              <div className="gallery_product filter creditcard">
                <img src="assets/images/logos/AMEX.png" />
              </div>
              <div className="gallery_product filter unsecuredloans creditcard homeloan improvement">
                <img src="assets/images/logos/AxisBank.png" />
              </div>
              <div className="gallery_product filter homeloan">
                <img src="assets/images/logos/BOB.png" />
              </div>
              <div className="gallery_product filter unsecuredloans">
                <img src="assets/images/logos/Cashe.png" />
              </div>
              <div className="gallery_product filter homeloan">
                <img src="assets/images/logos/Chola.png" />
              </div>
              {/* <div className="gallery_product filter bureau ">
                <img src="assets/images/logos/CIBIl.png" />
              </div> */}
              {/* <div className="gallery_product filter bureau">
                <img src="assets/images/logos/CRIF.png" />
              </div> */}
              <div className="gallery_product filter unsecuredloans">
                <img src="assets/images/logos/DMI.png" />
              </div>
              <div className="gallery_product filter unsecuredloans">
                <img src="assets/images/logos/EarlySalary.png" />
              </div>
              {/* <div className="gallery_product filter bureau">
                <img src="assets/images/logos/EQUIFAX.png" />
              </div> */}
              {/* <div className="gallery_product filter bureau">
                <img src="assets/images/logos/Experian.png" />
              </div> */}
              <div className="gallery_product filter unsecuredloans homeloan">
                <img src="assets/images/logos/FEDBank.png" />
              </div>
              <div className="gallery_product filter unsecuredloans">
                <img src="assets/images/logos/Flexi.png" />
              </div>
              <div className="gallery_product filter unsecuredloans creditcard homeloan improvement">
                <img src="assets/images/logos/HDFC.png" />
              </div>
              <div className="gallery_product filter homeloan">
                <img src="assets/images/logos/HDFCRED.png" />
              </div>
              <div className="gallery_product filter people">
                <img src="assets/images/logos/Hero.png" />
              </div>
              <div className="gallery_product filter homeloan">
                <img src="assets/images/logos/HHF.png" />
              </div>
              <div className="gallery_product filter unsecuredloans ">
                <img src="assets/images/logos/HomeCredit.png" />
              </div>
              <div className="gallery_product filter homeloan">
                <img src="assets/images/logos/homefirst.png" />
              </div>
              <div className="gallery_product filter unsecuredloans creditcard homeloan improvement">
                <img src="assets/images/logos/ICICI.png" />
              </div>
              <div className="gallery_product filter unsecuredloans homeloan improvement">
                <img src="assets/images/logos/IDFC.png" />
              </div>
              <div className="gallery_product filter unsecuredloans creditcard">
                <img src="assets/images/logos/Indiabulls.png" />
              </div>
              <div className="gallery_product filter unsecuredloans">
                <img src="assets/images/logos/INDIFI.png" />
              </div>
              <div className="gallery_product filter unsecuredloans">
                <img src="assets/images/logos/INDUSLND.png" />
              </div>
              <div className="gallery_product filter unsecuredloans homeloan improvement">
                <img src="assets/images/logos/KMB.png" />
              </div>
              <div className="gallery_product filter unsecuredloans">
                <img src="assets/images/logos/KridutBee.png" />
              </div>
              <div className="gallery_product filter unsecuredloans">
                <img src="assets/images/logos/Lendingkart.png" />
              </div>
              <div className="gallery_product filter people homeloan">
                <img src="assets/images/logos/LIC.png" />
              </div>
              <div className="gallery_product filter unsecuredloans homeloan">
                <img src="assets/images/logos/LTFinance.png" />
              </div>
              <div className="gallery_product filter unsecuredloans">
                <img src="assets/images/logos/Moneyview.png" />
              </div>
              <div className="gallery_product filter unsecuredloans">
                <img src="assets/images/logos/MuthootFinance.png" />
              </div>
              <div className="gallery_product filter unsecuredloans">
                <img src="assets/images/logos/NeoGrowth.png" />
              </div>
              <div className="gallery_product filter unsecuredloans">
                <img src="assets/images/logos/Paysense.png" />
              </div>
              <div className="gallery_product filter unsecuredloans">
                <img src="assets/images/logos/Piramal.png" />
              </div>
              <div className="gallery_product filter unsecuredloans creditcard">
                <img src="assets/images/logos/RBL.png" />
              </div>
              <div className="gallery_product filter people">
                <img src="assets/images/logos/Saison.png" />
              </div>
              <div className="gallery_product filter improvement">
                <img src="assets/images/logos/SBI.png" />
              </div>
              <div className="gallery_product filter improvement creditcard">
                <img src="assets/images/logos/SBICards.png" />
              </div>
              <div className="gallery_product filter people creditcard">
                <img src="assets/images/logos/SBM.png" />
              </div>
              <div className="gallery_product filter unsecuredloans">
                <img src="assets/images/logos/SME.png" />
              </div>
              <div className="gallery_product filter">
                <img src="assets/images/logos/SMFG.png" />
              </div>
              <div className="gallery_product filter unsecuredloans creditcard homeloan">
                <img src="assets/images/logos/StandardCharted.png" />
              </div>
              <div className="gallery_product filter unsecuredloans improvement">
                <img src="assets/images/logos/Stashfin.png" />
              </div>
              <div className="gallery_product filter unsecuredloans homeloan improvement">
                <img src="assets/images/logos/Tata.png" />
              </div>
              <div className="gallery_product filter improvement">
                <img src="assets/images/logos/TVS.png" />
              </div>
              <div className="gallery_product filter unsecuredloans">
                <img src="assets/images/logos/UGRO.png" />
              </div>
              <div className="gallery_product filter homeloan">
                <img src="assets/images/logos/Union.png" />
              </div>
              <div className="gallery_product filter people">
                <img src="assets/images/logos/YesBank.png" />
              </div>
            </div>
          </div>
        </section>

        {/* end logo filter */}

      </>

      {/* Start Free Quote Area
    <div className="free-quote-area pt-100 pb-100">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="single-free-quote-form">
              <div className="section-title left-title">
                <span className="top-title">Free Quote</span>
                <h2>Get An Insurance Quote To Get Started</h2>
              </div>
              <form>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Name"
                      />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="form-group">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email"
                      />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Select Type Of Insurance"
                      />
                    </div>
                  </div>
                </div>
             
                <button type="submit" className="default-btn">
                  Get A Quote Now
                </button>
              </form>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="free-quote-image">
              <div className="free-quote-main">
                <img src="assets/images/free-quote-1.webp" alt="free-quote" />
              </div>
              <div className="free-quote-shape">
                <img src="assets/images/free-quote-shape-1.webp" alt="shape3" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="free-quote-shape1">
        <img src="assets/images/free-quote-shape-2.webp" alt="shape3" />
      </div>
      <div className="free-quote-shape2">
        <img src="assets/images/free-quote-shape-3.webp" alt="shape3" />
      </div>
    </div>
    End Free Quote Area */}


      <Footer />
    </>

  );
}

export default Home;
